import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'
import { AUTH_SESSION_STALE_TIME } from '@/trpc/context.ts'
import { validateAuthSearch } from './-redirect.ts'

export const Route = createFileRoute('/auth')({
  validateSearch: validateAuthSearch,
  beforeLoad: async ({ context, location }) => {
    const session = await context.queryClient.fetchQuery({
      ...context.trpc.auth.session.queryOptions(),
      retry: false,
      staleTime: AUTH_SESSION_STALE_TIME
    })

    if (!session) {
      return
    }
    if (session.status === 'active' && session.member) {
      throw redirect({ to: '/home', replace: true })
    }
    if (location.pathname !== '/auth/status') {
      throw redirect({ to: '/auth/status', replace: true })
    }
    return { currentSession: session }
  },
  component: Outlet
})
